import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";
import { getAuthErrorMessage } from '../auth-error-message.util';
import { ConstantsService } from '../../constants.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('successMessage') successMessage!: ElementRef;

  isLoading = false;
  username!: string;
  password!: string;
  errorMessage!: string;
  loginForm!: FormGroup;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private authService: AuthService,
    private constantsService: ConstantsService
  ) {
  }

  ngOnInit() {
    this.constantsService.onReady(() => {
      this.loginForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.pattern(new RegExp(this.constantsService.getConstant('emailPattern')))]),
        password: new FormControl('', [Validators.required])
      });
    });
  }

  handleInput(event: any, type: string): void {
    const inputElement = event.target;
    if (inputElement.value.length > 0) {
      inputElement.classList.add('typing');
    } else {
      inputElement.classList.remove('typing');
    }
  }

  togglePassword(): void {
    const passwordField: HTMLInputElement = document.getElementById('password') as HTMLInputElement;
    const toggleIcon = document.getElementById('toggle-icon') as HTMLElement;
    if (passwordField.type === 'password') {
      passwordField.type = 'text';
      toggleIcon.classList.remove('fa-eye');
      toggleIcon.classList.add('fa-eye-slash');
    } else {
      passwordField.type = 'password';
      toggleIcon.classList.remove('fa-eye-slash');
      toggleIcon.classList.add('fa-eye');
    }
  }

  togglePasswordVisibility() {
    // Logic to toggle password visibility
    const passwordInput = document.getElementById('password') as HTMLInputElement;
    const toggleIcon = document.getElementById('toggle-icon') as HTMLElement;
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      toggleIcon.classList.replace('fa-eye', 'fa-eye-slash');
    } else {
      passwordInput.type = 'password';
      toggleIcon.classList.replace('fa-eye-slash', 'fa-eye');
    }
  }

  showLoading(): void {
    this.isLoading = true;
  }

  hideLoading(): void {
    this.isLoading = false;
  }


  onSubmit(): void {
    this.errorMessage = "";
    if (this.loginForm.valid) {
      this.showLoading();
      this.authenticateUser();
    }
  }

  authenticateUser() {
    this.authService.login(this.loginForm.value.email, this.loginForm.value.password).then((response) => {
      console.log('Login successful', response);
      this.router.navigate(['/shell']);
    }).catch((errorResponse: HttpErrorResponse) => {
      this.hideLoading();
      if (errorResponse) {
        console.log('Login failed', errorResponse);

        const mfaToken = errorResponse.error?.mfaToken;
        if (mfaToken && errorResponse.status === HttpStatusCode.PreconditionRequired) {
          this.router.navigate(['/mfa'], { queryParams: { token: mfaToken, email: this.loginForm.value.email }});
        } else {
          this.errorMessage = getAuthErrorMessage(
            errorResponse,
            'Invalid username or password. Please try again.'
          );
        }
      } else {
        this.errorMessage = 'An unexpected error occurred. Please try again later.';
      }
    })
  }
}
